// extracted by mini-css-extract-plugin
export default {"container":"confirm-modal_container__UBu2s","actions":"confirm-modal_actions__9jRXT","warning":"confirm-modal_warning__6J2EE"};